import { useEffect } from "react";
import { ConnectionStatusBannerSurface } from "@/components/connection-status-banner-surface";
import { Spinner } from "@/components/ui/spinner";
import { breadcrumb } from "@/lib/observability";

const SERVER_CONNECTION_RETRY_INTERVAL_MS = 3000;

interface ServerConnectionLostFallbackProps {
  resetError?: () => void;
}

export function ServerConnectionLostFallback({ resetError }: ServerConnectionLostFallbackProps) {
  useEffect(() => {
    breadcrumb(
      "network.server_connection_lost",
      { retryIntervalMs: SERVER_CONNECTION_RETRY_INTERVAL_MS },
      { category: "network", level: "warning" }
    );
  }, []);

  useEffect(() => {
    if (!resetError) {
      return;
    }

    const retryTimer = window.setInterval(() => {
      breadcrumb(
        "network.server_connection_retry",
        { retryIntervalMs: SERVER_CONNECTION_RETRY_INTERVAL_MS },
        { category: "network" }
      );
      resetError();
    }, SERVER_CONNECTION_RETRY_INTERVAL_MS);

    return () => {
      window.clearInterval(retryTimer);
    };
  }, [resetError]);

  return (
    <>
      <ConnectionStatusBannerSurface
        icon={<Spinner className="size-4" />}
        title="Connection to server lost"
        submessage="Reconnecting. Some content and actions may be unavailable."
        tone="server"
      />
      <div className="flex-1" aria-hidden="true" />
    </>
  );
}
